import { Injectable } from '@angular/core';

@Injectable()
export class PopupService {
  constructor() { }

  popupVisibility = {
    help: false,
    user: false
  }

  togglePopupVisibility(popupName: string): void {
    for (var property in this.popupVisibility) {
      if (property !== popupName) {
        this.popupVisibility[property] = false;
      }
    }

    this.popupVisibility[popupName] = !this.popupVisibility[popupName];
  }

  hideAllPopups() {
    this.popupVisibility.help = false;
    this.popupVisibility.user = false;
  }
}
